import { createFileRoute, Outlet } from '@tanstack/react-router'

import { automationQueries } from '@/features/air/automation-settings/queries'
import { caseQueries } from '@/features/air/case-management/queries'
import { AirTabs } from '@/features/air/components/tabs'
import { policyQueries } from '@/features/air/policy-management/queries'
import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { Section, SectionTitle } from '@/features/app-shell/section'

import { getCurrentTenant } from '@/shared/auth/store'

export const Route = createFileRoute('/_dashboard/air/_layout')({
	beforeLoad: ({ context: { queryClient } }) => {
		const tenant = getCurrentTenant()

		// Prefetch tabs queries (Case Management, Automations, Policies)

		if (tenant) {
			queryClient.prefetchInfiniteQuery(caseQueries.cases_list(tenant))
			queryClient.prefetchQuery(policyQueries.policies_list(tenant))
			queryClient.prefetchQuery(automationQueries.automations_list(tenant))
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Overview | Air | BitLyft AIR®',
			},
		],
	}),
	component: RouteComponent,
	pendingComponent: RouteSkeleton,
	errorComponent: RouteErrorComponent,
})

function RouteComponent() {
	return (
		<Section>
			<SectionTitle>Overview</SectionTitle>
			<AirTabs />

			<Outlet />
		</Section>
	)
}

function RouteSkeleton() {
	return (
		<Section>
			<SectionTitle>Overview</SectionTitle>
			<AirTabs />

			<Outlet />
		</Section>
	)
}
